import { Button } from "@mui/material";
import classNames from "classnames";
import * as React from "react";

import styles from "./Expandable.module.css";

interface ExpandableProps<T> {
  data: T;
  StartIcon?: React.ElementType;
  EndIcon?: React.ElementType;
  onClick?: (data: T) => void;
  className?: classNames.Argument;
  iconClassName?: classNames.Argument;
  disabled?: boolean;
  "aria-expanded"?: boolean;
  /** Id of the element this button reveals. */
  "aria-controls"?: string;
}

const noop = () => {};

/**
 * A subtle, textual button (optionally with an icon) that reveals more content when clicked.
 */
export function Expandable<T>(
  props: React.PropsWithChildren<ExpandableProps<T>>,
) {
  const {
    children,
    data,
    StartIcon,
    EndIcon,
    onClick = noop,
    disabled,
    "aria-expanded": ariaExpanded,
    "aria-controls": ariaControls,
  } = props;
  return (
    <Button
      aria-expanded={ariaExpanded}
      aria-controls={ariaControls}
      className={classNames(props.className, styles.button, {
        [styles.disabled]: disabled,
      })}
      disabled={disabled}
      startIcon={
        StartIcon !== undefined ? (
          <StartIcon className={props.iconClassName} />
        ) : undefined
      }
      endIcon={
        EndIcon !== undefined ? (
          <EndIcon className={props.iconClassName} />
        ) : undefined
      }
      onClick={() => onClick(data)}
      variant="text"
    >
      {children}
    </Button>
  );
}
